
import React from 'react'
import { SvgIconProps } from './Home'

const SvgAdminIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    fill="none"
    viewBox="0 0 19 20"
  >
    <path
      fill={fill ?? "#353535"}
      d="M17.348 2.555c-3.924-.31-6.196-1.961-6.506-2.168-.826-.516-1.858-.516-2.581 0 0 0-2.375 1.755-6.609 2.168C.722 2.658 0 3.484 0 4.413c0 11.664 8.364 15.38 8.777 15.484.207.103.516.103.723.103.207 0 .516 0 .723-.103.31-.103 8.777-3.82 8.777-15.484 0-.93-.723-1.755-1.652-1.858zM9.5 7.2c.93 0 1.652.723 1.652 1.548 0 .93-.723 1.549-1.652 1.549-.93 0-1.652-.723-1.652-1.549 0-.825.723-1.548 1.652-1.548zm3.717 1.548c0-1.96-1.652-3.51-3.717-3.51-2.065 0-3.717 1.55-3.717 3.51 0 .826.31 1.652.929 2.375-1.033.516-1.859 1.548-2.065 2.684-1.652-2.581-2.582-5.678-2.582-9.29C4.027 4.31 6.918 3.69 9.5 2.038c.62.413 3.201 2.064 7.435 2.477 0 3.613-.93 6.71-2.685 9.187-.207-1.135-.93-2.064-2.065-2.684.723-.516 1.032-1.342 1.032-2.27zM6.61 14.22c.103-.929.929-1.548 1.858-1.548h1.962c.93 0 1.756.62 1.859 1.548l.207 1.652c-1.343 1.342-2.685 1.961-2.995 2.168-.62-.31-1.755-.93-2.995-2.168l.104-1.652z"
    ></path>
  </svg>
)

export default SvgAdminIcon